<template>
    <div class="MessageContent" v-on:mouseleave="onLeaveMsgContent" v-on:mouseover="onFocusMsgContent" >
        <v-spacer v-if="!isUser"></v-spacer>
        <div style="background: transparent" class="message-text-container" v-on:mouseover="isActiveSuggestion = true">
            <v-avatar size="22" color="white" class="react-icon" v-if="react_icon">
              <emoji-parser :emoji="react_icon"/>
            </v-avatar>
            <!-- <emoji-parser :style="textColorStyle" class="text-pre message-text" :text="content.text" :bgColor="textMsgBgColor"/> -->
          <div class="message-text" :class="textClass" style="padding-top: 5px">
            <div class="row quote-message" v-if="quoteProps && isMessageDisplayQuote(quoteProps.message_type)">
              <div class="Message user"
                   style="position: relative;margin: 0;padding-top: 12px;padding-left: 6px">
                <div class="bottom">
                  <div class="content-container">
                    <div >
                      <div class="MessageContent">
                        <div class="message-text-container" style="background: transparent;">
                          <div class="message-text user" style="min-width: 120px">
                            <span v-if="quoteProps.message_type==='text'||quoteProps.message_type==='quick_reply'" 
                                  class="text-pre" style="word-break: normal">{{quoteProps.content.text}}</span>
                            <div v-if="quoteProps.message_type==='image'" style="background: #fff; border-radius: 5px; overflow: hidden">
                              <v-layout justify-center>
                                <img :src="quoteProps.content.url" alt="image"
                                    style="max-height: 150px; max-width: 150px; display: block"
                                />
                              </v-layout>
                              <div style="padding: 8px">
                                <div class="message-title" style="text-align: center" :title="quoteProps.content.title">
                                  {{ quoteProps.content.title }}
                                </div>
                              </div>
                            </div>
                            <div v-if="quoteProps.message_type==='file' && checkIfImage(quoteProps.content.url)" style="background: #fff; border-radius: 5px; overflow: hidden">
                              <v-layout justify-center>
                                <img :src="quoteProps.content.url" alt="image" style="max-height: 150px; max-width: 150px; display: block" />
                              </v-layout>
                              <div style="padding: 8px">
                                <div class="message-title" style="text-align: center" :title="quoteProps.content.file_name">
                                  {{ quoteProps.content.file_name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="icon-container" style="padding: 0">
                    <div class="avatar">
                      <div class="v-avatar" v-if="quoteProps.isUser"
                           style="height: 40px; width: 40px; background-color: #19AB66; ">
                        <span style="color: rgb(255, 255, 255);" >
                          {{$AppService.createTextImage(quoteProps.customer.name)}}
                        </span>
                      </div>
                      <div class="v-avatar" v-else
                           style="height: 40px; width: 40px; background-color: rgb(74, 105, 154); border-color: rgb(74, 105, 154);">
                        <span style="color: rgb(255, 255, 255);">
                          {{$AppService.createTextImage(bot.name)}}
                        </span>
                      </div>
                    </div>
                    <div class="time">{{ $AppService.createTextImage(quoteProps.createdTime) }}</div>
                  </div>
                </div>
                <div style="padding: 8px" v-if="quoteProps.content.buttons && quoteProps.content.buttons.length > 0">
                  <button class="message-btn" v-for="(b, ib) in quoteProps.content.buttons" :key="ib">
                    {{ b.title }}
                  </button>
                </div>
              </div>
              
            </div>

            <span v-html="textMsgParser" class="text-pre"></span>
          </div>

            <div style="padding: 8px" v-if="content.buttons && content.buttons.length > 0">
                <button class="message-btn" v-for="(b, ib) in content.buttons" :key="ib">
                    {{ b.title }}
                </button>
            </div>
        </div>
        <div style="width: 30px;position: relative">
          <button @click="notifyReplyEvent" v-if="showReplyBtn" style="padding: 12px;position: absolute;bottom: 0">
            <img src="/icon/backward.svg" width="16px" height="16px" alt=""/>
          </button>
        </div>
        <v-menu v-model="suggestionMenu" offset-x nudge-right="0" v-if="isShowSuggestionBtn">
          <template v-slot:activator="{on}">
            <v-btn icon small @click="onOpenSuggestion" class="btn-suggestion primary--text" :loading="loading">
              <icon-base :icon-color="suggestionMenu ? '#0152CC' : '#888A9A'" :icon-hover-color="suggestionMenu ? '#0152CC' : '#888A9A'">
                <icon-light-flash-line/>
              </icon-base>
            </v-btn>
          </template>
          <div class="suggestion">
            <div class="suggestion-header">
              <v-btn depressed class="text-none btn-mark-review" style="border-radius: 5px !important;" @click="onMarkReview" @mouseover="iconColor='white'" @mouseleave="iconColor='#888A9A'">
                <icon-base style="padding-right: 4px" :icon-color="iconColor" :icon-hover-color="iconColor">
                  <icon-check-fill/>
                </icon-base>
                {{$t('agentSuggestion.markToReview')}}
              </v-btn>
            </div>
            <div class="no-data" v-if="suggestions.messages && suggestions.messages.length < 1">
              <span>{{$t('agentSuggestion.noDataDisplay')}}</span>
            </div>
            <div class="suggestion-item" @click="onSelectSuggestion(msg)" v-for="msg of suggestions.messages" v-bind:key="msg.content" v-else>
              <div class="suggestion-data">
                <span><b>Intent </b> <b style="color: #19B458">({{ (msg.confidence * 100).toFixed(1) }}%)</b>: <span>{{ msg.intent }}</span></span>
              </div>
              <div class="suggestion-txt">
                {{msg.content}}
              </div>
            </div>
          </div>
        </v-menu>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";
import IconLightFlashLine from "components/icons/IconLightFlashLine";
import IconBase from "components/icons/IconBase";
import IconCheckFill from "components/icons/IconCheckFill";
import StaffService from "@/services/staff.service";
import {mapActions, mapState} from "vuex";
import {sync} from "vuex-pathify";
import $utils from "../../../utils/utils";

export default {
  name: "MessageContentText",
  components: {IconCheckFill, IconLightFlashLine, IconBase},
  data() {
    return {
      isActiveSuggestion: false,
      suggestionMenu: false,
      me: StaffService.getMe() ? StaffService.getMe() : {},
      loading: false,
      iconColor: '#888A9A',
      displayReply: false,
    }
  },
  extends: MessageContent,
    computed: {
      $utils() {
        return $utils
      },
        ...mapState(['botStatus', 'supporter', 'user', 'customer', 'notifyBotChat', 'bot']),
        ...mapState('agentSuggestion', ['suggestions']),
        ...mapState('config', ['botConfig']),
        sample: sync('agentSuggestion/sample'),
        chosen_intent: sync('agentSuggestion/chosen_intent'),
        textMsgBgColor() {
          return this.isUser ? "#fff" : "#0052CC"
        },
        textColorStyle() {
          return this.isUser ? "color: black" : "color:white"
        },
        textMsgParser() {
          const linkParser = this.replaceLinkInTextContent(this.content.text)
          return linkParser
        //   return Twemoji.parse(linkParser, {
        //     folder: "svg",
        //     ext: ".svg",
        //   });
        },
        isShowSuggestionBtn() {
          return this.isChatWithAgent && this.isUser && !this.botStatus && this.me && this.supporter
              && this.me.id === this.supporter.id && this.isActiveSuggestion && this.botConfig['enableSuggestionForAgent']
        },
        textClass() {
          let resultClass = '';
          if (this.isUser) {
            resultClass = 'user';
          } else {
            resultClass = 'bot';
          }
          if (this.isDeleted) {
            resultClass += ' deleted';
          }
          return resultClass;
        },
      showReplyBtn(){
          return !this.$parent.showClose&&this.displayReply&&this.isUser&&this.supporter&&this.supporter.id===this.user.id&&this.customer.currentCustomer.sender_channel==='zalo';
      }
    },
  methods: {
    ...mapActions('agentSuggestion', ['agentAction', 'fetchSuggestions']),
    onLeaveMsgContent() {
      if (!this.suggestionMenu && !this.loading) {
        this.isActiveSuggestion=false
      }
      this.displayReply=false;
    },
    onFocusMsgContent(){
      this.isActiveSuggestion=true;
      this.displayReply=true;
    },
    onSelectSuggestion(msg) {
      this.chosen_intent =msg.intent
      this.agentAction();
      this.$EventBus.$emit(this.$EventBusType.ON_SELECT_SUGGESTION, msg.content)
    },
    onMarkReview() {
      this.chosen_intent =""
      this.agentAction(true);
    },
    onOpenSuggestion() {
      if (!this.suggestionMenu) {
        this.sample = this.content.text
        this.loading = true
        this.fetchSuggestions((err)=> {
          if (!err) {
            this.suggestionMenu = true
          }
          this.loading = false
        })
      }
    },
    notifyReplyEvent(){
      this.$parent.$emit('reply');
    },
    checkIfImage (fileName) {
      if (['line', 'google_biz_msg', 'instagram'].includes(this.content.file_provider)) {
        return this.content.file_type === 'image'
      }

      // check image have params
      // 118324519_344777646899344_7689171552145064415_n.jpg?_nc_cat=102&_nc_sid=b96e70&_nc_ohc=qW51MRyVAyQAX9Aj1u6&_nc_ad=z-m&_nc_cid=0&_nc_ht=scontent.xx&oh=bbfc5dd744a938e2f11db1408da693b7&oe=5F6C1CBD
      try {
        if (fileName) {
          let name_un_params = fileName.split('?')[0];
          let ext = name_un_params.split('.').pop().toLowerCase();
          let imageExt = ['tif', 'png', 'gif', 'ico', 'jpg', 'jpeg', 'svg'];
          return imageExt.indexOf(ext) >= 0;
        }
        return false
      } catch (e) {
        return false
      }
    },
    isMessageDisplayQuote(message_type){
      switch (message_type) {
        case "text":
        case "image":
        case "file":
        case "quick_reply":
            return true;
      }
      return false;
    },
  },
  watch: {
    notifyBotChat(val) {
      if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.MARK_AS_DONE) {
        this.suggestionMenu = false;
      }
    },
    suggestionMenu() {
      this.isActiveSuggestion = this.suggestionMenu
    },
  }
}
</script>
<style scoped lang="scss">
  @import "../../style/message-box.scss";
  ::v-deep.react-icon {
    position: absolute;
    bottom: -10px;
    right: 5px;
  }
  ::v-deep.menuable__content__active {
    border-radius: 10px;
    filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));
    box-shadow: none !important;
  }
  .suggestion {
    background-color: #ECECF8;
    border-radius: 10px;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    gap: 1px;
    margin-left: 10px;
    :first-of-type {
      border-radius: 10px 10px 0 0 !important;
    }
    :last-of-type {
      border-radius: 0 0 10px 10px !important;
    }
    .suggestion-header {
      height: 46px;
      background-color: white;
      width: 100%;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn-mark-review {
        margin: 0 !important;
        font-size: 14px !important;
        background-color: #F6F6FB;
        color: black;
      }
      .btn-mark-review:hover {
        color: white;
        background-color: #0052CC !important;
      }
      .btn-suggestion {
        height: 30px;
        margin: 0 !important;
        border-radius: 5px !important;
        padding: 0 10px;
      }
    }
    .no-data {
      width: 500px;
      max-width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F6F6FB;
      color: #8E909F;
    }
    .suggestion-item {
      cursor: pointer;
      height: 84px;
      width: 100%;
      background-color: white;
      display: flex;
      padding: 10px;
      gap: 4px;
      flex-direction: column;
      .suggestion-data {
        display: flex;
        gap: 50px;
        color: #454545;
      }
      .suggestion-txt {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.2;
      }
    }
  }
  .suggestion-item:hover {
    background-color: #F6F6FB;
  }
  
  .message-text.user.deleted {
    background: lightgray;
    font-style: italic;
    opacity: 0.5;
  }
</style>
